/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Flex from '../Flex';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';

export const AdvanceTableFooter = ({
  viewAllBtn,
  navButtons,
  className,
  rowInfo,
  rowsPerPageSelection,
  rowsPerPageSelection_inner,
  rowsPerPageSelection_filter,
  rowsPerPageOptions = [10, 20, 30, 40, 50],
  rowsPerPageOptions_inner = [5, 8, 10],
  onPageChange // 부모로부터 전달받는 콜백 함수
}) => {
  const {
    setPageSize,
    previousPage,
    nextPage,
    getCanNextPage,
    getCanPreviousPage,
    getState,
    getPrePaginationRowModel,
    getPaginationRowModel
  } = useAdvanceTableContext();

  const {
    pagination: { pageSize, pageIndex }
  } = getState();
  const [perPage] = useState(pageSize);
  const [isAllVisible, setIsAllVisible] = useState(false);

  const handlePageSizeChange = e => {
    const newPageSize = Number(e.target.value);
    setPageSize(newPageSize);
    if (onPageChange) {
      onPageChange(0, newPageSize); // 현재 페이지와 새로운 페이지 크기를 부모로 전달
    }
  };

  const handlePreviousPage = () => {
    if (getCanPreviousPage()) {
      previousPage();
      if (onPageChange) {
        onPageChange(pageIndex - 1, pageSize); // 이전 페이지와 현재 페이지 크기 전달
      }
    }
  };

  const handleNextPage = () => {
    if (getCanNextPage()) {
      nextPage();
      if (onPageChange) {
        onPageChange(pageIndex + 1, pageSize); // 다음 페이지와 현재 페이지 크기 전달
      }
    }
  };

  return (
    <Flex
      className={classNames(
        className,
        'align-items-center justify-content-between'
      )}
    >
      <Flex alignItems="center" className="fs-10">
        {rowInfo && (
          <p className="mb-0">
            <span className="d-none d-sm-inline-block me-2">
              {pageSize * pageIndex + 1} to{' '}
              {pageSize * pageIndex + getPaginationRowModel().rows.length} of{' '}
              {getPrePaginationRowModel().rows.length}
            </span>
            {viewAllBtn && (
              <>
                <span className="d-none d-sm-inline-block me-2">&mdash;</span>
                <Button
                  variant="link"
                  size="sm"
                  className="py-2 px-0 fw-semibold"
                  onClick={() => {
                    setIsAllVisible(!isAllVisible);
                    setPageSize(
                      isAllVisible
                        ? perPage
                        : getPrePaginationRowModel().rows.length
                    );
                  }}
                >
                  View {isAllVisible ? 'less' : 'all'}
                  <FontAwesomeIcon
                    icon="chevron-right"
                    className="ms-1 fs-11"
                  />
                </Button>
              </>
            )}
          </p>
        )}

        {rowsPerPageSelection_filter && (
          <>
            {/* <p className="mb-0 mx-2"></p> */}

            <Form.Select
              size="sm"
              className="input-hover"
              style={{ height: '35px', width: '80px', paddingTop: 0, paddingBottom: 0 }}
              // onChange={e => setPageSize(Number(e.target.value))}
              onChange={handlePageSizeChange} // 페이지 크기 변경 핸들러
              defaultValue={pageSize}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
        {rowsPerPageSelection && (
          <>
            {/* <p className="mb-0 mx-2"></p> */}

            <Form.Select
              size="sm"
              className="w-100 input-hover"
              // onChange={e => setPageSize(Number(e.target.value))}
              onChange={handlePageSizeChange} // 페이지 크기 변경 핸들러
              defaultValue={pageSize}
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              {rowsPerPageOptions.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
        {rowsPerPageSelection_inner && (
          <>
            <Form.Select
              size="sm"
              className="w-auto input-hover"
              // onChange={e => setPageSize(Number(e.target.value))}
              onChange={handlePageSizeChange} // 페이지 크기 변경 핸들러
              defaultValue={pageSize}
              style={{ height: '35px', paddingTop: 0, paddingBottom: 0 }}
            >
              {rowsPerPageOptions_inner.map(value => (
                <option value={value} key={value}>
                  {value}
                </option>
              ))}
            </Form.Select>
          </>
        )}
      </Flex>
      {navButtons && (
        <Flex>
          <Button
            size="sm"
            variant={getCanPreviousPage() ? 'primary' : 'tertiary'}
            onClick={() => previousPage()}
            className={classNames({ disabled: !getCanPreviousPage() })}
          >
            Previous
          </Button>
          <Button
            size="sm"
            variant={getCanNextPage() ? 'primary' : 'tertiary'}
            className={classNames('px-4 ms-2', {
              disabled: !getCanNextPage()
            })}
            onClick={() => nextPage()}
          >
            Next
          </Button>
        </Flex>
      )}
    </Flex>
  );
};

export default AdvanceTableFooter;
